/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */

import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { Alert, Button, Row } from 'reactstrap';
import Pagination from 'rc-pagination';

import del from '../../../../Res/Icon/delete.png';
import edit from '../../../../Res/Icon/edit.png';

import DownloadIcon from '../../../../Res/Icon/download.png';
import DeleteIcon from '../../../../Res/Icon/cancel.png';
import AnalyzingIcon from '../../../../Res/Icon/analyzing.png';
import PinnedIcon from '../../../../Res/Icon/pinned.png';
import UnPinnedIcon from '../../../../Res/Icon/un-pinned.png';
import { ENG_LOCALE } from '../../../../lib/constants';
import AnalyzerModal from './AnalyzerModal';
import { useState } from 'react';
import SortIcons from '../../../ProposalsSortIcons';
import utils from '../../../../lib/utils';

import Spinner from '../../../Spinner/Spinner';
// import filterIcon from '../../../../Res/Icon/filter.png';

export const NotesTable = memo(
  ({
    handleEditNote,
    onEditNote,
    boxNotes,
    onDownload,
    handleDeleteNote,
    handleChangePagination,
    onPageChange,
    shouldFilter,
    user,
    onDeleteRecording,
    updateFetchQuery,
    box,
    onSort,
    sortValue,
    selectedTab
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [note, setNote] = useState(null);
    const [file, setFile] = useState(null);
    const [isLoaderOpen, setIsLoaderOpen] = useState(false); // Add this state variable


    const handlePinnedRecording = async e => {
      const { docs } = boxNotes;
      let totalPinned = 0;
      docs.forEach(pin => {
        pin.pinned && (totalPinned += 1);
      });
      if (e.pinned) {
        await onEditNote({ ...e, pinned: !e.pinned }, e._id);
        await updateFetchQuery();
      } else if (totalPinned < 5) {
        await onEditNote({ ...e, pinned: !e.pinned }, e._id);
        await updateFetchQuery();
      } else {
        toast.error("You can't pin more than 5 recordings.");
      }
    };

    const onDownloadAttachment = useCallback((e, name) => {
      onDownload(e, name);
    }, []);

      const analyzeAudio = async note => {
        try {
          setIsLoaderOpen(true); // Set to true when starting to load
          let res = await onDownload(note._id, note.attachment.name, true);
          if(res) {
            setNote(note);
            setFile(res);
            setIsOpen(true);
          } else {
            toast.error('File does not exist');
          }
          
        } catch (error) {
          console.error('Error analyzing audio:', error);
        } finally {
          
          setIsLoaderOpen(false); // Set back to false when analysis is done (success or failure)
        }
      };

    return (
      <div className="viewContainer">
        <div className="table-header-fixed" style={{ height: '46vh' }}>
          <table>
            <thead>
              <tr>
                <th />
                <th onClick={() => onSort('email')}>
                  Email <SortIcons sortObj={sortValue} sortName="email" />
                </th>
                <th onClick={() => onSort('note')}>
                  Note <SortIcons sortObj={sortValue} sortName="note" />
                </th>
                <th onClick={() => onSort('type')}>
                  Type <SortIcons sortObj={sortValue} sortName="type" />
                </th>
                <th onClick={() => onSort('createdAt')}>
                  Time <SortIcons sortObj={sortValue} sortName="createdAt" />
                </th>
                <th>Attachment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {boxNotes?.length !== 0 && boxNotes?.docs?.length !== 0 ? (
                boxNotes?.docs?.map(box => (
                  <tr key={Math.random().toString()}>
                    <td>
                      <Button
                        style={{ background: 'inherit', border: 'none', display: 'flex' }}
                        onClick={() => handlePinnedRecording(box)}
                        title={box.pinned ? 'Unpin Recording' : 'Pin Recording'}
                      >
                        <img
                          style={{ height: '20px' }}
                          src={box.pinned ? PinnedIcon : UnPinnedIcon}
                          alt="..."
                        />
                      </Button>
                    </td>
                    <td>{box.user ? box.user.email : '-'}</td>
                    <td>{box.note}</td>
                    <td>{box.type}</td>
                    <td>{utils.getDateTimeFormat(box.createdAt, 'both')}</td>
                    <td>
                      {box.attachment && box.attachment.name && (
                        <Row>
                          <Button
                            style={{ background: 'inherit', border: 'none', display: 'flex' }}
                            onClick={() => onDownloadAttachment(box._id, box.attachment.name)}
                            title="Download"
                          >
                            <img style={{ height: '28px' }} src={DownloadIcon} alt="..." />
                            <p style={{ color: '#000000' }} className="attachment-text">
                              {box.attachment.name}
                            </p>
                          </Button>
                          <Button
                            style={{
                              background: 'inherit',
                              border: 'none',
                              display: 'flex',
                              padding: 0,
                            }}
                            onClick={() => onDeleteRecording(box)}
                            title="Delete"
                          >
                            <img style={{ height: '20px' }} src={DeleteIcon} alt="..." />
                          </Button>
                        </Row>
                      )}
                    </td>
                    <td>     {isLoaderOpen && <Spinner />}
                    
                      {(box.attachment && box.attachment.name && selectedTab === '3') && (
                        <Button
                          style={{
                            background: 'inherit',
                            border: 'none',
                            display: 'flex',
                            padding: 0,
                          }}
                          onClick={() => {
                                setIsLoaderOpen(true); // Set to true when starting to load
                                analyzeAudio(box)
                              }
                           }
                        >
                          <img style={{ height: '20px' }} src={AnalyzingIcon} alt="..." />
                        </Button>
                      )}
                    </td>
                    <td style={{ display: 'flex' }}>
                      {box.user && user._id === box.user._id ? (
                        <>
                          <img
                            className="actions-icon"
                            src={edit}
                            onClick={() => handleEditNote(box)}
                            alt="edit"
                          />
                          <img
                            className="actions-icon"
                            src={del}
                            onClick={() => handleDeleteNote(box)}
                            alt="delete"
                          />
                        </>
                      ) : null}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>
                    <Alert rowSpan={10} color="info">
                      No notes added
                    </Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {boxNotes?.totalPages > 1 && (
          <Pagination
            locale={ENG_LOCALE}
            className="pagination-container"
            onChange={shouldFilter ? onPageChange : handleChangePagination}
            current={boxNotes?.page}
            total={boxNotes?.totalDocs}
            pageSize={boxNotes?.limit}
            showLessItems
            showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
          />
        )}
        {isOpen && (
          <AnalyzerModal note={note} file={file} isOpen={isOpen} onClose={() => setIsOpen(false)} />
        )}
      </div>
    );
  },
);
